import mitt from 'mitt';

const emitter = mitt();

export default {
  scrollToTop() {
    emitter.emit("scrollToTop");
  },
  scrollToTopMobile(val) {
    emitter.emit("scrollToTopMobile", val);
  },
  checkConsumerDirect(val) {
    console.log('event bus being called!!!!!', val);
    emitter.emit("checkConsumerDirect", val);
  },
  on: emitter.on,
  off: emitter.off
};
